<div style="text-align:right;">
  <button class="btn btn-info btn-xs mr-2" aria-expanded="false"
    (click)="visualizarMatriz()">
    <i class="far fas fa-eye mr-1"></i> Visualizar </button>
</div>
<div class="card-body p-0" *ngIf="dataSource2?.data?.length > 0; else content">
  <div id="accordion-unidades">
    <div *ngFor="let unidade of dataSource2.data; index as i">
      <div class="card p-0">
        <div class="card-header" id="heading-ug-{{i}}">
          <h5 class="mb-0">
            <div class="d-flex justify-content-between align-items-center">
              <button class="btn btn-link limit-text" data-toggle="collapse" attr.data-target="#collapse-ug-{{i}}"
                      aria-expanded="true" attr.aria-controls="collapse-ug-{{i}}">
                {{unidade?.unidadeGestora.nome}}
              </button>
            </div>
          </h5>
        </div>

        <div id="collapse-ug-{{i}}" class="collapse"
             attr.aria-labelledby="heading-ug-{{i}}" attr.data-parent="#accordion-unidades">

          <ng-container *ngIf="unidade?.subtipoAuditoria">
            <div id="accordion-subtipos-ug-{{i}}">
              <div class="card">
                <div class="card-header" id="heading-subtipo-ug-{{i}}">
                  <h5 class="mb-0">
                    <button class="btn btn-link" data-toggle="collapse"
                            attr.data-target="#collapse-subtipo-ug-{{i}}"
                            aria-expanded="true"
                            attr.aria-controls="collapse-subtipo-ug-{{i}}">
                      {{unidade.subtipoAuditoria?.nome}}
                    </button>
                  </h5>
                </div>

                <div id="collapse-subtipo-ug-{{i}}" class="collapse"
                     attr.aria-labelledby="heading-subtipo-ug-{{i}}"
                     attr.data-parent="#accordion-subtipos-ug-{{i}}">

                  <ng-container *ngIf="unidade?.subtipoAuditoria?.subtipoAuditoriaMatrizPlanejamento?.length > 0; else noData">
                    <div id="accordion-matrizes-ug-{{i}}">
                      <div *ngFor="let subtipo of unidade.subtipoAuditoria.subtipoAuditoriaMatrizPlanejamento; index as j">
                        <div class="card">
                          <div class="card-header" id="heading-subtipo-matriz-{{j}}-ug-{{i}}">
                            <h5 class="mb-0">
                              <button class="btn btn-link" data-toggle="collapse"
                                      attr.data-target="#collapse-subtipo-matriz-{{j}}-ug-{{i}}"
                                      aria-expanded="true"
                                      attr.aria-controls="collapse-subtipo-matriz-{{j}}-ug-{{i}}">
                                {{subtipo?.matrizPlanejamento?.nome}}
                              </button>
                              <button *ngIf="!visualizar && tipoTrabalho.nome==='planejamento'" class="btn btn-primary btn-xs mr-2" aria-expanded="false"
                                      (click)="abrirModalAdicionarItem(subtipo, subtipo?.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento, unidade.subtipoAuditoria.id ,unidade.unidadeGestora.id, id)">
                                <i class="fas fa-plus"></i> Adicionar Questão
                              </button>
                            </h5>
                          </div>

                          <div id="collapse-subtipo-matriz-{{j}}-ug-{{i}}" class="collapse"
                               attr.aria-labelledby="heading-subtipo-matriz-{{j}}-ug-{{i}}"
                               attr.data-parent="#accordion-matrizes-ug-{{i}}">

                            <div class="card-body p-0 mat-elevation-z1">
                              <app-listagem-questoes
                                [visualizar]="visualizar"
                                (excluirItemEvento)="obter()"
                                [planejamentoId]="id"
                                [subtipoId]="subtipo?.subtipoAuditoriaId"
                                [matrizPlanejamento]="subtipo?.matrizPlanejamento"
                                [listaDados]="subtipo?.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento"
                                [unidadeGestoraId]="unidade.unidadeGestora.id"
                                [displayedColumns]="displayedColumns">
                              </app-listagem-questoes>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #noData>
                    <h5 class="table-no-data">Para disponibilizar a Matriz de Planejamento é necessário vincular a UG na aba de Informações Básicas.</h5>
                  </ng-template>

                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-body p-0">
  <ng-template #content>
    <h5 class="table-no-data">
      Para disponibilizar a Matriz de Planejamento é necessário vincular a UG na aba de Informações Básicas.
    </h5>
  </ng-template>
</div>
